<form [formGroup]="formGroup" style="width: calc(100% - 20px)">
  @if (showSlider&&min!=null&&max!=null) {
    <div class="w100">
      <mat-slider></mat-slider>
    </div>
  }
  @if (title) {
    <div class="w100" style="padding: 10px">
      {{title}}
    </div>
  }
  <div class="flex-between-center">
    <div class="widthMinMax">
      <mat-form-field appearance="outline" class="w100">
        <mat-label>{{ 'min'|translate }}</mat-label>
        <input matInput formControlName="minValue" type="number" [step]="step" [max]="maxInputMin$|async">
        <button mat-icon-button matPrefix (click)="$event.stopPropagation();unsetValue('minValue')">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="widthMinMax">
      <mat-form-field appearance="outline" class="w100">
        <mat-label>{{ 'max'|translate }}</mat-label>
        <input matInput formControlName="maxValue" type="number" [step]="step" [min]="minInputMax$|async">
        <button mat-icon-button matPrefix (click)="$event.stopPropagation();unsetValue('maxValue')">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</form>